import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=7d0b6d48&scoped=true"
import script from "./home2.vue?vue&type=script&lang=js"
export * from "./home2.vue?vue&type=script&lang=js"
import style0 from "./home2.vue?vue&type=style&index=0&id=7d0b6d48&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0b6d48",
  null
  
)

export default component.exports